/* This is a workaround to select active element */
/* When tab is pressed */
/* In a nutshell - 'tab' pressed event is replaced with 'enter' pressed event */
import React from 'react';

export function selectOnLeaveHandler(event: React.KeyboardEvent<HTMLElement>): void {
	if (event.key.toLowerCase() === 'tab') {
		const _event = new KeyboardEvent('keydown', {
			key: 'Enter',
			code: 'Enter',
			keyCode: 13,
			bubbles: true,
		});

		event.target.dispatchEvent(_event);
	}
}
